import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Drawer, Grid, Button } from '@mui/material';
import { Dashboard } from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';
import { useUserData } from '../../hooks/useUserData';
import Logo from '../../assets/images/logocenit2.png';
import Mobile from './Mobile';
import './styles.scss';

const ADMIN_PROFILES = ['Admin', 'administrador', 'superAdmin', 'Super Administrador', 'dev'];

function MenuToolbar() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { userData } = useUserData();
  const [openMenu, setOpenMenu] = useState(false);
  const urlHome = '/home';

  useEffect(() => {
    if (user) {
      console.log('Usuario activo');
    } else {
      console.log('No hay usuario activo.');
    }
  }, [user]);

  const toggleDrawer = () => {
    setOpenMenu((prev) => !prev);
  };

  return (
    <>
      <div className="header-toolbar">
        <Grid container alignItems="center" justifyContent="space-between">
          {/* Logo con flecha morada */}
          <Grid item xs={6} md={3} className="logo-wrapper">
            <div className="header-logo-container">
              <img
                src={Logo}
                alt="logo"
                className="logo-header"
                onClick={() => navigate(urlHome)}
              />
            </div>
          </Grid>

          {/* Botón Admin — solo visible si el perfil es administrador */}
          {/* {userData && ADMIN_PROFILES.includes(userData.perfil) && (
            <Grid item className="header-right">
              <Button
                variant="contained"
                startIcon={<Dashboard />}
                onClick={() => navigate('/admin/dashboard')}
                sx={{
                  bgcolor: 'rgba(255,255,255,0.15)',
                  color: '#fff',
                  borderRadius: '20px',
                  textTransform: 'none',
                  fontWeight: 600,
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' },
                }}
              >
                Admin
              </Button>
            </Grid>
          )} */}
        </Grid>
      </div>

      {/* Drawer menú móvil */}
      <Drawer anchor="right" open={openMenu} onClose={toggleDrawer}>
        <div className="menu-mobile-drawer">
          <Mobile />
        </div>
      </Drawer>
    </>
  );
}

export default MenuToolbar;
